import { IFormViewForm } from 'components/FormView';

const LocalShipmentOutputForm: IFormViewForm = {
    id: 'LocalShipmentOutputForm',
    layout: {
        rows: 1,
        columns: 1
    },
    fields: [
        {
            id: '1',
            position: {
                row: 1,
                col: 1,
                colspan: 3
            },
            type: 'PAPER_CONTAINER',
            props: {
                elevation: 0
            },
            children: [
                {
                    id: 0,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '35%',
                    },
                    props: {
                        name: 'OutputLocalShipmentDespatch',
                        label: 'Local Shipment Despatch'
                    }
                },
                {
                    id: 1,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '65%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'LocalShipmentDespatchOutput',
                        fieldId: 'LocalShipmentDespatchOutput',
                        documentType: 'SO',
                        precedentFields: ['OutputLocalShipmentDespatch'],
                        isCustomerSupplierScoped: true
                    }
                },
            ]
        }
    ]
};
export default LocalShipmentOutputForm;
